import {Popover} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

const ConsignmentLiveTrackingHeading = () => {

    return (
        <OverlayTrigger
            key="top"
            placement="top"
            overlay={
                <Popover id="live-tracking-popover">
                    <Popover.Header as="h3">Live Tracking</Popover.Header>
                    <Popover.Body>
                        On the morning of your delivery a live tracking link will appear here and remain for up to 6 weeks.
                    </Popover.Body>
                </Popover>
            }
        >
            <strong><FontAwesomeIcon icon={faInfoCircle}/> Live Tracking</strong>
        </OverlayTrigger>
    )

}

export default ConsignmentLiveTrackingHeading;
